import React from 'react'
import { connect } from 'react-redux';
import ConfirmModal from './ConfirmModal';
import ContactReplyModal from './ContactReplyModal';

export const MODEL_TYPE_CONFIRM = 'MODAL_CONFIRM';
export const MODEL_TYPE_CONTACT_REPLY = 'MODAL_CONTACT_REPLY';

const MODAL_COMPONENTS = {}

MODAL_COMPONENTS[MODEL_TYPE_CONFIRM] = ConfirmModal;
MODAL_COMPONENTS[MODEL_TYPE_CONTACT_REPLY] = ContactReplyModal;

const ModalRoot = ({ modalType, modalProps }) => {

  if (!modalType) {
    return null
  }

  const SpecificModal = MODAL_COMPONENTS[modalType]
  return <SpecificModal {...modalProps} />
}

export default connect( state => state.modal )(ModalRoot)



// WEBPACK FOOTER //
// ./src/pages/modal/ModalRoot.js